

















































































import Vue from 'vue';
import { createNamespacedHelpers, mapState as mapRootState } from 'vuex';
import Page from '../components/Page.vue';
import InputText from '../components/common/form/InputText.vue';
import FormInput from '../components/common/form/FormInput.vue';
import InputPassword from '../components/common/form/InputPassword.vue';
import Card from '../components/common/Card.vue';
import CTAButton from '../components/common/buttons/CTAButton.vue';
import Errors from '@/components/common/form/Errors.vue';
import { normalizeRefNo } from '@/utils/utils';
import { RawLocation } from 'vue-router';
const { mapState, mapActions, mapGetters, mapMutations } = createNamespacedHelpers('session');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;

export default Vue.extend({
    components: { CTAButton, Page, Card, InputText, FormInput, InputPassword, Errors },
    data: function() {
        return {
            refNo: '',
            password: '',
            isLoading: false,
        };
    },
    computed: {
        ...mapCustomLabelsState([
            'accessGrievanceTitle',
            'accessGrievanceInfo',
            'grievanceRefNo',
            'grievanceRefNoFormat',
            'grievanceNumberPlaceholder',
            'portalTitle',
            'instanceTitle',
        ]),
        ...mapRootState(['instanceId']),
        ...mapState(['isVerifying']),
        ...mapGetters(['getFieldErrors', 'isFormValid']),
        toForgotPasswordLink(): RawLocation {
            if (this.refNo) {
                return {
                    name: 'ForgotPasswordPage',
                    params: { instanceId: this.instanceId },
                    query: { refNo: this.refNo },
                };
            } else {
                return {
                    name: 'ForgotPasswordPage',
                    params: { instanceId: this.instanceId },
                };
            }
        },
    },
    created() {
        document.title = `${this.instanceTitle} | ${this.accessGrievanceTitle} | ${this.portalTitle}`;
    },
    mounted() {
        this.refNo = (this.$route.query.refNo as string) || '';
    },
    methods: {
        ...mapMutations(['clearError']),
        async submit() {
            this.isLoading = true;
            try {
                const normalizedRefNo = normalizeRefNo(this.refNo);
                await this.verify({ refNo: normalizedRefNo, password: this.password });
                if (!this.isFormValid) {
                    return;
                }
                await this.$router.push(`/${this.$route.params.instanceId}/grievance/${normalizedRefNo}`);
            } finally {
                this.isLoading = false;
            }
        },
        ...mapActions(['verify']),
    },
});
